import { useState } from "react";
import Matchmaking, { STATES } from "../../model/matchmaking";
import { setMatchmakingState, setMatchmakingOponnentId, setMatchmakingChannelId } from "../providers/matchmaking";

export function useMatchmaking(): [Matchmaking, Function, Function, Function] {
    const [state, setState] = useState({ state: STATES.CONNECTING, opponentId: "", channelId: "" });
    // console.log("useMatchmaking");
    return [state,
        (matchmakingState: STATES) => setMatchmakingState(setState, matchmakingState),
        (opponentId: string) => setMatchmakingOponnentId(setState, opponentId),
        (channelId: string) => setMatchmakingChannelId(setState, channelId),
    ];
}
